import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { el } from "date-fns/locale";
import { element } from "protractor";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../services/common.service";
import * as moment from "moment";

@Component({
  selector: "app-customer-book-appointment",
  templateUrl: "./customer-book-appointment.component.html",
  styleUrls: ["./customer-book-appointment.component.scss"],
})
export class CustomerBookAppointmentComponent implements OnInit {
  loading: boolean = false;
  isSubmitted: boolean = false;
  isMobileView: boolean = false;
  isLimitReached: boolean = false;
  isProductBlocked: boolean = false;
  isLinkTurnedOff: boolean = false;
  headData: any = null;
  category = [];
  selectedCat: any = null;
  selectedType: any = null;
  ownerNumber = null;
  productWarningText: string = "";
  linkOffMessage: string = "";
  enquiryTitle: string = "";
  enquiryDescription: string = "";
  bookingTitle: string = "";
  bookingDescription: string = "";

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.isMobileView = this.commonService.isMobile();
    let slug = this.router.url.split("/customer/book-appointment/")[1];
    sessionStorage.setItem("slug", slug);
    this.commonService.newAppointmentData.slug = slug;
    if (this.commonService.newAppointmentData.appointmentType) {
      this.selectedType = this.commonService.newAppointmentData.appointmentType;
    }
    this.getMetaData();

    // get the source of link
    let referrer = document.referrer;
    let source: string = "";
    const checkLocalStorageSource = sessionStorage.getItem("source");
    if (checkLocalStorageSource == null) {
      if (referrer.includes("facebook")) {
        source = "Facebook";
        sessionStorage.setItem("source", source);
      } else if (referrer.includes("google")) {
        source = "Google";
        sessionStorage.setItem("source", source);
      } else {
        source = "Others";
        sessionStorage.setItem("source", source);
      }
      const checkLocalStorageSource = sessionStorage.getItem("source");
    }
  }

  getMetaData() {
    this.loading = true;
    this.commonService.getAppointmentMetaData().subscribe(
      (data: any) => {
        if (data.code === 200) {
          this.isLinkTurnedOff = false;
          let res = data.data;
          let outletStatus = res["outlet_status"];
          let subscriptionEndDate = res.subscription_end_date;
          let remainingAppointmentLimit =
            res.appointment_limit - res.appointment_usage;
          // check outlet status is Active and appointment usage is reached the limit
          let isAppointmentAllowedForActive =
            outletStatus == "Active" && remainingAppointmentLimit <= 0;

          // check outlet status is Trial and subscription end date is before current date
          let isTrialExpired = moment(new Date()).isAfter(
            moment(subscriptionEndDate, "YYYY-MM-DD"),
            "date"
          );

          let isAppointmentAllowedForTrial =
            outletStatus == "Trial" && isTrialExpired;

          this.ownerNumber = res.owner_number;
          if (res.is_product_blocked) {
            this.isProductBlocked = true;
            this.productWarningText = res.product_warning_text;
          } else if (
            isAppointmentAllowedForActive ||
            isAppointmentAllowedForTrial
          ) {
            this.isLimitReached = true;
          }
          let headerData = {
            outlet: res.business_outlet_name,
            business: res.business_name,
            business_logo: res.business_logo,
            is_welcome_banner_text: this.isMobileView
              ? res.appointment_setting_details.is_short_welcome_banner_text
              : res.appointment_setting_details.is_welcome_banner_text,
            welcome_banner_text: this.isMobileView
              ? res.appointment_setting_details.short_welcome_banner_text
              : res.appointment_setting_details.welcome_banner_text,
          };
          this.commonService.newAppointmentData.headerData = headerData;
          this.headData = headerData;

          // set booking and enquiry blocks data
          this.bookingTitle =
            res.appointment_setting_details.consumer_booking_title;
          this.bookingDescription =
            res.appointment_setting_details.consumer_booking_description;
          this.enquiryTitle =
            res.appointment_setting_details.consumer_enquiry_title;
          this.enquiryDescription =
            res.appointment_setting_details.consumer_enquiry_description;

          //set theme color and color with opacity here. Replace var with theme color.
          const primaryColor =
            res.appointment_setting_details.primary_color_theme;
          this.commonService.newAppointmentData.themeColor = primaryColor;
          sessionStorage.setItem("theme_color", primaryColor);
          document.documentElement.style.setProperty(
            "--custom-color",
            primaryColor
          );
          document.documentElement.style.setProperty(
            "--custom-color-100",
            this.commonService.convertHexToRgb(primaryColor, 0.1)
          );

          let catData = [];
          res.categories?.forEach((element: any) => {
            if (element?.category_name && element.category_name.length) {
              element.active = false;
              element.category_name = this.commonService.capitalizeString(
                element?.category_name
              );
              catData.push(element);
            }
          });

          if (res.appointment_setting_details.enable_appointment_category) {
            this.category = catData;
            this.commonService.newAppointmentData.categoryData = catData;
          }

          if (!this.isProductBlocked && !this.isLimitReached) {
            if (
              res.appointment_setting_details.consumer_booking_type?.toUpperCase() ==
              "ENQUIRY"
            ) {
              this.selectedType = 1;
              this.goToNext();
            }
            if (
              res.appointment_setting_details.consumer_booking_type?.toUpperCase() ==
              "BOOKING"
            ) {
              this.selectedType = 2;
              this.goToNext();
            }
          }
          this.loading = false;
        }
      },
      (error: any) => {
        if (error.status == 422) {
          if (error.error.consumer_booking == false) {
            this.isLinkTurnedOff = true;
            let businessDetail = error.error.business_detail;
            let headerData = {
              outlet: businessDetail.business_outlet_name,
              business: businessDetail.business_name,
              business_logo: businessDetail.business_logo,
              website: businessDetail.business_website,
              email: businessDetail.email_id,
              phone: businessDetail.owner_number,
            };
            this.headData = headerData;
          }
        }
        this.loading = false;
        this.linkOffMessage = error.error?.message;
      }
    );
  }

  selectCategory(index) {
    this.category.forEach((element: any) => {
      element.active = false;
    });
    this.category[index].active = true;
    this.selectedCat = this.category[index];
  }

  public selectAppointmentType(index: number) {
    this.selectedType = index;
  }

  public goToNext() {
    this.isSubmitted = true;

    if (!this.selectedType) {
      return;
    }

    this.commonService.newAppointmentData.appointmentType = this.selectedType;
    if (this.selectedType == 1) {
      this.isSubmitted = false;
      this.router.navigateByUrl("/customer/inquiry", {
        state: this.selectedCat,
        // replaceUrl: true,
      });
    } else if (this.selectedType == 2) {
      this.isSubmitted = false;
      this.router.navigateByUrl("/customer/book-appointment", {
        state: this.selectedCat,
        // replaceUrl: true,
      });
    } else {
      this.toastr.error("Please select the type of appointment");
    }
  }
}
